module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687bd6bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/University/Overview.vue
// module id = 709
// module chunks = 1